import React, { useState } from 'react';
import { I18n } from 'src/domains/layouts/webview/components/language/I18n';
import { ContainerConfigType } from 'src/domains/sportsbook/webview/components/scoreboards/liveTracker/ContainerConfig';
import {
    LiveTrackerIFrameWrapper,
    LiveTrackerToggleWrapper,
    LiveTrackerWrapper,
    ScoreboardWrapper,
    SportWidget,
} from 'src/domains/sportsbook/webview/components/scoreboards/liveTracker/LiveTrackerIframe.style';
import { observer } from 'src/utils/mobx-react';
import { LiveTrackerIframeState } from './LiveTrackerIframe.state';
import { UniverseComponent } from 'src/domains/common/universes';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';

interface ReferencePropsType {
    eventId: number;
    providerName: string;
    containerConfig: ContainerConfigType;
    isOpen: boolean;
}

export const LiveTrackerIframe = observer(
    'LiveTrackerIframe',
    ({ eventId, providerName, containerConfig, isOpen }: ReferencePropsType): JSX.Element => {
        const [state] = useState(() => new LiveTrackerIframeState(isOpen));
        const common = useCommon();
        const configState = ConfigComponents.get(common).config;

        setTimeout(() => {
            const widgetParams = document.createElement('script');
            widgetParams.type = 'text/javascript';
            widgetParams.innerHTML = `
            var widget_params = {
                container_id: '${containerConfig.containerId}',
                id: '${eventId}',
                provider: '${providerName}',
                onError: function(err){console.log('error', err);} 
            };
        `;

            const widgetScript = document.createElement('script');
            widgetScript.src = containerConfig.scriptSrc;

            document.body.appendChild(widgetParams);
            document.body.appendChild(widgetScript);
        }, 0);

        return (
            <LiveTrackerIFrameWrapper variant={configState.componentVariants.sportsbookVariant}>
                <LiveTrackerToggleWrapper
                    handleToggle={state.toggle}
                    isOpen={state.isOpen}
                    title={
                        <I18n
                            langKey='scoreboard.live-tracker.title'
                            defaultText='Live tracker'
                        />
                    }
                />

                <UniverseComponent>
                    {(universeVersion): React.ReactElement => (
                        <LiveTrackerWrapper
                            bgImage={universeVersion.liveTrackerBgUrl}
                            isOpen={state.isOpen}
                        >
                            <SportWidget id={containerConfig.containerId} />
                            <ScoreboardWrapper eventId={eventId} />
                        </LiveTrackerWrapper>
                    )}
                </UniverseComponent>
            </LiveTrackerIFrameWrapper>
        );
    }
);
